module.exports = __webpack_public_path__ + "img/icon-2.fa04c3d0.png";